import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export const useInvoices = (page = 1, perPage = 10) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['companyInvoices', page, perPage],
        queryFn: async () => {
            const res = await api.get(`/company/invoices?per_page=${perPage}&page=${page}`);
            if (!res.data || !res.data.success) {
                throw new Error(res.data?.message || 'Failed to fetch invoices');
            }
            return res.data.data;
        },
        keepPreviousData: true,
        staleTime: 1000 * 60 * 5,
    });

    const invoices = (data?.data || []).map(inv => ({
        id: inv.id,
        total: inv.total,
        services: inv.services || [],
        client: inv.client || {},
        createdAt: inv.created_at,
        status: inv.status || (parseFloat(inv.total) > 0 ? 'paid' : 'pending'),
        raw: inv
    }));

    const pagination = {
        currentPage: data?.current_page || page,
        lastPage: data?.last_page || 1,
        total: data?.total || 0,
        hasNext: !!data?.next_page_url,
        hasPrev: !!data?.prev_page_url,
    };

    return {
        invoices,
        pagination,
        isLoading,
        error,
        refetch,
    };
};
